import Message from '../common/Message'
import React from 'react'
import {useSelector} from 'react-redux'
import {path} from 'ramda'

export default function ShareMessage() {
  const shareStatus = useSelector(path(['createGame', 'shareStatus']))
  const showShareStatus = useSelector(path(['createGame', 'showShareStatus']))

  return <Message visible={showShareStatus}>{shareStatus}</Message>
}